import { IData } from '@hooks/useData';
import { useMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { ICliente } from '@model/Cliente';
import { IClienteEvento } from '@model/ClienteEvento';
import { IComboClienteEventoStatus } from '@model/ClienteEventoStatus';
import { IComboClienteEventoTipo } from '@model/ClienteEventoTipo';
import { IClienteEventoFilter } from '@services/ClienteService';
import React from 'react';
import { EventoCancelarModal } from './EventoCancelarModal';
import { EventoFilter } from './EventoFilter';
import { EventoMenu } from './EventoMenu';
import { EventoRegistrarModal } from './EventoRegistrarModal';
import { EventoTable } from './EventoTable';

export type ClienteDetalhesEventosProps = {
    cliente: ICliente
    data: IData<IClienteEvento, IClienteEventoFilter>
    clienteEventoTipoCombo: IComboClienteEventoTipo
    clienteEventoStatusCombo: IComboClienteEventoStatus
    isLoading: boolean
}

export function ClienteDetalhesEventos ({ cliente, data, isLoading, clienteEventoTipoCombo, clienteEventoStatusCombo }: ClienteDetalhesEventosProps) {
    const registrarModal = useModalWindow();
    const cancelarModal = useModalWindow();
    const menu = useMenu();

    return (
        <React.Fragment>
            <EventoFilter
                filter={data.filter}
                clienteEventoTipoCombo={clienteEventoTipoCombo}
                clienteEventoStatusCombo={clienteEventoStatusCombo}
                isLoading={isLoading}
                registrarModal={registrarModal}
            />
            
            <EventoTable
                data={data}
                menu={menu}
                isLoading={isLoading}
            />

            <EventoRegistrarModal 
                modal={registrarModal}
                cliente={cliente}
                clienteEventoTipoCombo={clienteEventoTipoCombo}
                onEventoRegistrado={data.filter.handleFilterRequest}
            />

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <EventoCancelarModal
                            modal={cancelarModal}
                            clienteEvento={data.focusedRow}
                            onEventoCancelado={data.handleUpdateFocusedRow}
                        />
        
                        <EventoMenu 
                            cancelarModal={cancelarModal}
                            clienteEvento={data.focusedRow}
                            menu={menu}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}